/* ================================================================
   HIFRUITTY — THEME.JS
   Cart, Accordion, Gallery, Quantity, FAQ, Interactions
   ================================================================ */

(function () {
  'use strict';

  /* ────────────────────────────────────
     3. BUY NOW
     ──────────────────────────────────── */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-product-form]');
      if (!form) return;
      var variantId = form.querySelector('[data-variant-id]');
      var qtyInput = form.querySelector('[data-qty-input]');
      if (variantId) {
        var id = variantId.value;
        var qty = qtyInput ? qtyInput.value : 1;
        window.location.href = '/cart/' + id + ':' + qty;
      }
    });
  });

  /* ────────────────────────────────────
     4. PRODUCT GALLERY — Swipeable carousel with dots + arrows
     ──────────────────────────────────── */
  (function () {
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    var mainImgWrap = document.getElementById('mainImageWrap');
    var mainImg = document.getElementById('mainImage');
    var mainVideo = document.getElementById('mainVideo');
    var mainExternalVideo = document.getElementById('mainExternalVideo');
    if (!mainImgWrap || thumbs.length === 0) return;

    var images = [];
    thumbs.forEach(function (thumb) {
      images.push({ src: thumb.dataset.src, type: thumb.dataset.mediaType || 'image', el: thumb });
    });
    var currentIndex = 0;

    // Wrap gallery-main in .gallery-slider so arrows sit OUTSIDE overflow:hidden
    var sliderWrap = document.createElement('div');
    sliderWrap.className = 'gallery-slider';
    mainImgWrap.parentNode.insertBefore(sliderWrap, mainImgWrap);
    sliderWrap.appendChild(mainImgWrap);

    // Inject dot indicators after slider wrap
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'gallery-dots';
    images.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(dot);
    });
    sliderWrap.parentNode.insertBefore(dotsWrap, sliderWrap.nextSibling);

    // Inject prev/next arrows into sliderWrap (outside overflow:hidden)
    ['prev', 'next'].forEach(function (dir) {
      var btn = document.createElement('button');
      btn.className = 'gallery-arrow gallery-arrow--' + dir;
      btn.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
      btn.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        goTo(dir === 'prev' ? currentIndex - 1 : currentIndex + 1);
      });
      sliderWrap.appendChild(btn);
    });

    function goTo(index) {
      index = ((index % images.length) + images.length) % images.length;
      if (!images[index]) return;
      var item = images[index];

      if (mainVideo) mainVideo.pause();

      thumbs.forEach(function (t) { t.classList.remove('active'); });
      item.el.classList.add('active');
      try { item.el.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); } catch (e) {}
      dotsWrap.querySelectorAll('.gallery-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === index);
      });

      var fadeTargets = [mainImg, mainVideo, mainExternalVideo].filter(Boolean);
      fadeTargets.forEach(function (el) {
        el.style.transition = 'opacity 0.22s ease';
        if (el.style.display !== 'none') el.style.opacity = '0';
      });

      setTimeout(function () {
        if (mainImg) mainImg.style.display = 'none';
        if (mainVideo) mainVideo.style.display = 'none';
        if (mainExternalVideo) mainExternalVideo.style.display = 'none';

        if (item.type === 'video' && mainVideo) {
          var source = mainVideo.querySelector('source');
          if (source) source.src = item.src;
          mainVideo.load();
          mainVideo.style.display = 'block';
          mainVideo.style.opacity = '1';
        } else if (item.type === 'external_video' && mainExternalVideo) {
          mainExternalVideo.src = item.src;
          mainExternalVideo.style.display = 'block';
          mainExternalVideo.style.opacity = '1';
        } else {
          if (mainImg) {
            mainImg.src = item.src;
            mainImg.style.display = 'block';
            mainImg.style.opacity = '1';
          }
        }

        currentIndex = index;
      }, 180);
    }

    // Thumbnail click
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    // Touch swipe on main image
    var touchStartX = 0;
    var touchStartY = 0;
    mainImgWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    mainImgWrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx < 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });
  })();

  /* ────────────────────────────────────
     5. QUANTITY SELECTOR
     ──────────────────────────────────── */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.purchase-row') || btn.closest('.qty-selector').parentElement;
      var display = wrap.querySelector('[data-qty-value]');
      var input = wrap.querySelector('[data-qty-input]');
      var val = parseInt(display.textContent, 10);
      if (val > 1) {
        val--;
        display.textContent = val;
        if (input) input.value = val;
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.purchase-row') || btn.closest('.qty-selector').parentElement;
      var display = wrap.querySelector('[data-qty-value]');
      var input = wrap.querySelector('[data-qty-input]');
      var val = parseInt(display.textContent, 10);
      val++;
      display.textContent = val;
      if (input) input.value = val;
    });
  });

  /* ────────────────────────────────────
     6. VARIANT SELECTOR (PDP)
     ──────────────────────────────────── */
  document.querySelectorAll('.variant-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var siblings = btn.closest('.variant-options').querySelectorAll('.variant-option');
      siblings.forEach(function (s) { s.classList.remove('variant-option--active'); });
      btn.classList.add('variant-option--active');
      if (window.__productJSON) updateVariantFromOptions();
    });
  });

  // Color swatch selector
  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      var siblings = swatch.closest('.color-options').querySelectorAll('.color-swatch');
      siblings.forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      if (window.__productJSON) updateVariantFromOptions();
    });
  });

  function updateVariantFromOptions() {
    if (!window.__productJSON) return;
    var selected = [];
    document.querySelectorAll('.option-group, .variant-section').forEach(function (sec) {
      var active = sec.querySelector('.variant-option--active, .color-swatch.active');
      if (active) selected.push(active.dataset.optionValue);
    });

    var match = window.__productJSON.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    if (match) {
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = match.id;

      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) priceEl.textContent = formatMoney(match.price);

      var compareEl = document.querySelector('[data-product-compare-price]');
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      var saveEl = document.querySelector('[data-product-save]');
      if (saveEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          saveEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price);
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      var atcBtn = document.querySelector('[data-add-to-cart]');
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (match.available) {
          atcBtn.textContent = 'Add to cart — ' + formatMoney(match.price);
        } else {
          atcBtn.textContent = 'Sold Out';
        }
      }
    }
  }

  /* ────────────────────────────────────
     7. PRODUCT ACCORDION (PDP v2)
     ──────────────────────────────────── */
  document.querySelectorAll('[data-pdp-accordion]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.accordion-item');
      var wasOpen = item.classList.contains('open');
      var accordion = item.closest('.accordions');
      if (accordion) {
        accordion.querySelectorAll('.accordion-item').forEach(function (ai) {
          ai.classList.remove('open');
          ai.querySelector('.accordion-body').style.maxHeight = '0';
        });
      }
      if (!wasOpen) {
        item.classList.add('open');
        var body = item.querySelector('.accordion-body');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // Legacy accordion support (data-accordion-trigger)
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion__item');
      if (!item) return;
      var wasOpen = item.classList.contains('accordion__item--open');
      var accordion = item.closest('[data-accordion]');
      if (accordion) {
        accordion.querySelectorAll('.accordion__item').forEach(function (i) {
          i.classList.remove('accordion__item--open');
        });
      }
      if (!wasOpen) item.classList.add('accordion__item--open');
    });
  });

  /* ────────────────────────────────────
     8. FAQ ACCORDION & SEARCH
     ──────────────────────────────────── */
  // FAQ toggle
  document.querySelectorAll('[data-faq-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.faq-item');
      var wasOpen = item.classList.contains('faq-item--open');
      var group = item.closest('.faq-group');
      if (group) {
        group.querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('faq-item--open');
        });
      }
      if (!wasOpen) item.classList.add('faq-item--open');
    });
  });

  // FAQ category tabs
  var catTabs = document.querySelectorAll('.cat-tab');
  var faqGroups = document.querySelectorAll('.faq-group');

  catTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.dataset.category;
      var searchInput = document.getElementById('faqSearch');
      if (searchInput) {
        searchInput.value = '';
        var clearBtn = document.getElementById('searchClear');
        if (clearBtn) clearBtn.classList.remove('visible');
        var countEl = document.getElementById('searchCount');
        if (countEl) countEl.textContent = '';
        var noRes = document.getElementById('noResults');
        if (noRes) noRes.classList.remove('visible');
      }

      document.querySelectorAll('.faq-item').forEach(function (item) {
        item.classList.remove('faq-item--hidden', 'faq-item--open');
      });

      catTabs.forEach(function (t) { t.classList.remove('cat-tab--active'); });
      tab.classList.add('cat-tab--active');

      faqGroups.forEach(function (g) { g.classList.remove('active'); });
      var target = document.querySelector('[data-group="' + cat + '"]');
      if (target) target.classList.add('active');
    });
  });

  // FAQ search
  var faqSearch = document.getElementById('faqSearch');
  var searchClear = document.getElementById('searchClear');
  var searchCount = document.getElementById('searchCount');
  var noResults = document.getElementById('noResults');

  if (faqSearch) {
    faqSearch.addEventListener('input', function () {
      var query = faqSearch.value.toLowerCase().trim();
      if (searchClear) searchClear.classList.toggle('visible', query.length > 0);

      if (query.length === 0) {
        if (searchCount) searchCount.textContent = '';
        if (noResults) noResults.classList.remove('visible');
        document.querySelectorAll('.faq-item').forEach(function (item) {
          item.classList.remove('faq-item--hidden', 'faq-item--open');
        });
        var activeCat = document.querySelector('.cat-tab--active');
        if (activeCat) {
          var activeCatHandle = activeCat.dataset.category;
          faqGroups.forEach(function (g) {
            g.classList.toggle('active', g.dataset.group === activeCatHandle);
          });
        }
        return;
      }

      faqGroups.forEach(function (g) { g.classList.add('active'); });

      var matchCount = 0;
      document.querySelectorAll('.faq-item').forEach(function (item) {
        var question = item.querySelector('[data-faq-trigger]') ? item.querySelector('[data-faq-trigger]').textContent.toLowerCase() : '';
        var answer = item.querySelector('.faq-answer__body') ? item.querySelector('.faq-answer__body').textContent.toLowerCase() : '';
        var keywords = item.dataset.keywords || '';
        var searchable = question + ' ' + answer + ' ' + keywords;
        var matches = searchable.includes(query);
        item.classList.toggle('faq-item--hidden', !matches);
        if (!matches) item.classList.remove('faq-item--open');
        if (matches) matchCount++;
      });

      // Hide empty groups
      faqGroups.forEach(function (g) {
        var visible = g.querySelectorAll('.faq-item:not(.faq-item--hidden)');
        g.style.display = visible.length === 0 ? 'none' : '';
      });

      if (searchCount) {
        searchCount.textContent = matchCount > 0 ? matchCount + ' result' + (matchCount > 1 ? 's' : '') + ' found' : '';
      }
      if (noResults) noResults.classList.toggle('visible', matchCount === 0);
    });

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        faqSearch.value = '';
        faqSearch.dispatchEvent(new Event('input'));
        faqSearch.focus();
      });
    }
  }

  /* ────────────────────────────────────
     9. MOBILE MENU DRAWER
     ──────────────────────────────────── */
  var mobileDrawer = document.getElementById('mobile-menu');

  function openMobileMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.add('open');
    mobileDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('menu-open');
  }

  function closeMobileMenu() {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('open');
    mobileDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('menu-open');
  }

  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openMobileMenu);
  });

  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeMobileMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMobileMenu();
  });

  /* ────────────────────────────────────
     10. SCROLL REVEAL ANIMATION
     ──────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseFloat(entry.target.dataset.delay) || 0;
          setTimeout(function () {
            entry.target.classList.add('visible');
          }, delay * 1000);
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal, .pcard').forEach(function (el, i) {
      if (el.classList.contains('pcard')) {
        el.dataset.delay = (i * 0.1).toString();
      }
      revealObserver.observe(el);
    });
  }

  /* ────────────────────────────────────
     11. EXPERTS CAROUSEL (simple scroll)
     ──────────────────────────────────── */
  var carouselTrack = document.querySelector('.experts__track');
  var carouselPrev = document.querySelector('[data-carousel-prev]');
  var carouselNext = document.querySelector('[data-carousel-next]');

  if (carouselTrack && carouselPrev && carouselNext) {
    var scrollAmount = 380;
    carouselPrev.addEventListener('click', function () {
      carouselTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    carouselNext.addEventListener('click', function () {
      carouselTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  /* ────────────────────────────────────
     12. COLLECTION ADD-TO-CART (non-PDP forms)
     ──────────────────────────────────── */
  document.querySelectorAll('.pcard__btn, .rcard__btn').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form || form.hasAttribute('data-product-form')) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '✓ Added!';
      btn.style.background = '#22C55E';
      btn.style.color = '#fff';
      btn.style.borderColor = '#22C55E';

      var formData = new FormData(form);
      var id = formData.get('id');
      var qty = formData.get('quantity') || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: parseInt(qty, 10) }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.openCartDrawer) window.openCartDrawer();
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.style.color = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.innerHTML = 'Error';
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.style.color = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 1600);
        });
    });
  });

  /* ────────────────────────────────────
     13. PDP ADD-TO-CART → AJAX + CART DRAWER
     ──────────────────────────────────── */
  var pdpForm = document.querySelector('form[data-product-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pdpForm.querySelector('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '✓ Added!';
      btn.style.background = '#22C55E';
      btn.style.color = '#fff';

      var formData = new FormData(pdpForm);
      var id = formData.get('id');
      var qty = formData.get('quantity') || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: parseInt(qty, 10) }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.openCartDrawer) window.openCartDrawer();
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          btn.innerHTML = 'Error';
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
          }, 1600);
        });
    });
  }

  /* ────────────────────────────────────
     14. STICKY ATC BAR (mobile)
     ──────────────────────────────────── */
  var stickyBar = document.getElementById('stickyAtcBar');
  var stickyBtn = document.getElementById('stickyAtcBtn');
  var mainAtcBtn = document.querySelector('[data-add-to-cart]');

  if (stickyBar && mainAtcBtn && window.innerWidth <= 768) {
    var hasScrolledPastAtc = false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          hasScrolledPastAtc = true;
          stickyBar.classList.remove('visible');
        } else if (hasScrolledPastAtc) {
          stickyBar.classList.add('visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(mainAtcBtn);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        mainAtcBtn.click();
      });
    }
  }

  /* ────────────────────────────────────
     15. WISHLIST TOGGLE (visual only)
     ──────────────────────────────────── */
  document.querySelectorAll('.pcard__wishlist, .gallery__wishlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var svg = btn.querySelector('svg');
      if (!svg) return;
      var isFilled = svg.getAttribute('fill') === '#E83E6C';
      svg.setAttribute('fill', isFilled ? 'none' : '#E83E6C');
      btn.style.background = isFilled ? '' : 'var(--pink-light)';
    });
  });

  /* ────────────────────────────────────
     14. CONTACT FAQ TOGGLE
     ──────────────────────────────────── */
  document.querySelectorAll('[data-contact-faq-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.cfaq-item');
      var body = item.querySelector('.cfaq-body');
      var isOpen = item.classList.contains('open');

      // Close all siblings
      document.querySelectorAll('.cfaq-item').forEach(function (fi) {
        fi.classList.remove('open');
        fi.querySelector('.cfaq-body').style.maxHeight = '0';
      });

      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     15. AVO PRODUCT TABS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-avo-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = parseInt(tab.dataset.avoTab, 10);
      document.querySelectorAll('.avo-product-tab').forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });
      document.querySelectorAll('.avo-tab-panel').forEach(function (p, i) {
        p.classList.toggle('active', i === index);
      });
    });
  });

  /* ────────────────────────────────────
     16. AVO GALLERY THUMBNAILS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-avo-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.avo-gallery-small').forEach(function (s) { s.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('avoMainImg');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.3s ease';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 250);
      }
    });
  });

  /* ────────────────────────────────────
     17. AVO PRODUCT ACCORDION
     ──────────────────────────────────── */
  document.querySelectorAll('[data-avo-prod-accordion]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.avo-prod-accordion');
      var body = item.querySelector('.avo-prod-accordion-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.avo-prod-accordion').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.avo-prod-accordion-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     18. AVO FAQ TOGGLE
     ──────────────────────────────────── */
  document.querySelectorAll('[data-avo-faq-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.avo-faq-item');
      var body = item.querySelector('.avo-faq-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.avo-faq-item').forEach(function (fi) {
        fi.classList.remove('open');
        fi.querySelector('.avo-faq-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     19. APPLE PRODUCT TABS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-apple-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = parseInt(tab.dataset.appleTab, 10);
      document.querySelectorAll('.apple-product-tab').forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });
      document.querySelectorAll('.apple-tab-panel').forEach(function (p, i) {
        p.classList.toggle('active', i === index);
      });
    });
  });

  /* ────────────────────────────────────
     20. APPLE GALLERY THUMBNAILS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-apple-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.apple-gallery-small').forEach(function (s) { s.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('appleMainImg');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.3s ease';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 250);
      }
    });
  });

  /* ────────────────────────────────────
     21. APPLE PRODUCT ACCORDION
     ──────────────────────────────────── */
  document.querySelectorAll('[data-apple-prod-acc]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.apple-prod-acc');
      var body = item.querySelector('.apple-prod-acc-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.apple-prod-acc').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.apple-prod-acc-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     22. APPLE FAQ TOGGLE
     ──────────────────────────────────── */
  document.querySelectorAll('[data-apple-faq-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.apple-faq-item');
      var body = item.querySelector('.apple-faq-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.apple-faq-item').forEach(function (fi) {
        fi.classList.remove('open');
        fi.querySelector('.apple-faq-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     23. APPLE TESTIMONIAL CAROUSEL
     ──────────────────────────────────── */
  (function () {
    var dataEl = document.querySelector('[data-apple-testimonials]');
    if (!dataEl) return;
    var testimonials = JSON.parse(dataEl.textContent);
    var tIdx = 0;
    var quoteEl = document.querySelector('[data-apple-testimonial-quote]');
    var authorEl = document.querySelector('[data-apple-testimonial-author]');
    var dots = document.querySelectorAll('[data-apple-dot]');

    function showTestimonial(i) {
      tIdx = i;
      if (quoteEl) quoteEl.textContent = testimonials[i].quote;
      if (authorEl) authorEl.textContent = testimonials[i].author;
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    }

    var nextBtn = document.querySelector('[data-apple-testimonial-next]');
    var prevBtn = document.querySelector('[data-apple-testimonial-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { showTestimonial((tIdx + 1) % testimonials.length); });
    if (prevBtn) prevBtn.addEventListener('click', function () { showTestimonial((tIdx - 1 + testimonials.length) % testimonials.length); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { showTestimonial(parseInt(dot.dataset.appleDot, 10)); });
    });
  })();

  /* ────────────────────────────────────
     25. MANGO PRODUCT TABS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-mango-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = parseInt(tab.dataset.mangoTab, 10);
      document.querySelectorAll('.mango-product-tab').forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });
      document.querySelectorAll('.mango-tab-panel').forEach(function (p, i) {
        p.classList.toggle('active', i === index);
      });
    });
  });

  /* ────────────────────────────────────
     26. MANGO GALLERY THUMBNAILS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-mango-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.mango-gallery-small').forEach(function (s) { s.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = document.getElementById('mangoMainImg');
      if (mainImg && thumb.dataset.src) {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.3s ease';
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 250);
      }
    });
  });

  /* ────────────────────────────────────
     27. MANGO PRODUCT ACCORDION
     ──────────────────────────────────── */
  document.querySelectorAll('[data-mango-prod-acc]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.mango-prod-acc');
      var body = item.querySelector('.mango-prod-acc-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.mango-prod-acc').forEach(function (a) {
        a.classList.remove('open');
        a.querySelector('.mango-prod-acc-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     28. MANGO FAQ TOGGLE
     ──────────────────────────────────── */
  document.querySelectorAll('[data-mango-faq-toggle]').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.closest('.mango-faq-item');
      var body = item.querySelector('.mango-faq-body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.mango-faq-item').forEach(function (fi) {
        fi.classList.remove('open');
        fi.querySelector('.mango-faq-body').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  /* ────────────────────────────────────
     29. MANGO TESTIMONIAL CAROUSEL
     ──────────────────────────────────── */
  (function () {
    var dataEl = document.querySelector('[data-mango-testimonials]');
    if (!dataEl) return;
    var testimonials = JSON.parse(dataEl.textContent);
    var tIdx = 0;
    var quoteEl = document.querySelector('[data-mango-testimonial-quote]');
    var authorEl = document.querySelector('[data-mango-testimonial-author]');
    var dots = document.querySelectorAll('[data-mango-dot]');

    function showTestimonial(i) {
      tIdx = i;
      if (quoteEl) quoteEl.textContent = testimonials[i].quote;
      if (authorEl) authorEl.textContent = testimonials[i].author;
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
    }

    var nextBtn = document.querySelector('[data-mango-testimonial-next]');
    var prevBtn = document.querySelector('[data-mango-testimonial-prev]');
    if (nextBtn) nextBtn.addEventListener('click', function () { showTestimonial((tIdx + 1) % testimonials.length); });
    if (prevBtn) prevBtn.addEventListener('click', function () { showTestimonial((tIdx - 1 + testimonials.length) % testimonials.length); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { showTestimonial(parseInt(dot.dataset.mangoDot, 10)); });
    });
  })();

  /* ────────────────────────────────────
     30. COMPARISON TABS
     ──────────────────────────────────── */
  document.querySelectorAll('[data-comp-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = parseInt(tab.dataset.compTab, 10);
      document.querySelectorAll('.comparison-tab').forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });
      document.querySelectorAll('.comp-panel').forEach(function (p, i) {
        p.classList.toggle('active', i === index);
      });
    });
  });

  /* ────────────────────────────────────
     15. SCROLL ANIMATIONS (product page sections)
     ──────────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var pdpObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          pdpObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.faq-card, .product-card, .expert-card, .review-card, .info-card, .social-card, .contact-trust-card, .avo-designed-card, .avo-action-card, .avo-related-card, .avo-faq-item, .apple-edging-step, .apple-tapping-feat, .apple-related-card, .apple-faq-item, .apple-session-card, .mango-edging-step, .mango-tapping-feat, .mango-related-card, .mango-faq-item, .mango-session-card').forEach(function (el, i) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'all 0.5s ease ' + (i * 0.08) + 's';
      pdpObserver.observe(el);
    });
  }

})();

(function () {
  var btnComparisonATC = document.querySelector('[data-comparison-atc]');
  if (!btnComparisonATC) return;

  btnComparisonATC.addEventListener('click', function (e) {
    e.preventDefault();

    var pdpForm = document.querySelector('form[data-product-form]');
    if (!pdpForm) return;

    var idInput = pdpForm.querySelector('[data-variant-id], input[name="id"]');
    if (!idInput || !idInput.value) return;

    var variantId = parseInt(idInput.value, 10);
    if (!variantId) return;

    var originalHTML = btnComparisonATC.innerHTML;
    var originalBg = btnComparisonATC.style.background;
    var originalColor = btnComparisonATC.style.color;
    btnComparisonATC.disabled = true;
    btnComparisonATC.innerHTML = '✓ Added!';
    btnComparisonATC.style.background = '#22C55E';
    btnComparisonATC.style.color = '#fff';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.openCartDrawer) window.openCartDrawer();
        setTimeout(function () {
          btnComparisonATC.disabled = false;
          btnComparisonATC.innerHTML = originalHTML;
          btnComparisonATC.style.background = originalBg;
          btnComparisonATC.style.color = originalColor;
        }, 1500);
      })
      .catch(function () {
        btnComparisonATC.disabled = false;
        btnComparisonATC.innerHTML = originalHTML;
        btnComparisonATC.style.background = originalBg;
        btnComparisonATC.style.color = originalColor;
      });
  });
})();
